import { getSessionValue, setSessionValue } from './sessionHelper';
const CACHE_DURATION = 30 * 60 * 1000; // 30 minutes
const CACHE_KEY = 's3UrlCache';
export const getS3url = async (s3Key, preview, fetcher) => {
    const key = `${preview ? 'preview' : 'original'}-${s3Key}`;
    // check if we have a cached url
    const cached = getSessionValue(CACHE_KEY, {})[key];
    // check if the cached url is still valid
    if (cached && cached.fetchedAt > Date.now() - CACHE_DURATION) {
        return cached.s3Url;
    }
    else {
        const s3Url = await fetcher(s3Key);
        if (s3Url) {
            const cache = getSessionValue(CACHE_KEY, {});
            setSessionValue(CACHE_KEY, {
                ...cache,
                [key]: {
                    s3Key,
                    s3Url,
                    preview,
                    fetchedAt: Date.now(),
                },
            });
        }
        return s3Url;
    }
};
